import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface ChartsWatchlistItem {
  id: string;
  ticker: string;
  companyName: string;
  logo: string;
  marketCap: number;
  exchange: string;
  createdAt: string;
}

export interface ChartsWatchlistMeta {
  total: number;
  displayed: number;
  message: string | null;
}

export interface ChartsWatchlistResponse {
  data: ChartsWatchlistItem[];
  meta: ChartsWatchlistMeta;
}

// Hook to get limited, shuffled watchlist for charts page
export const useChartsWatchlist = () => {
  return useQuery({
    queryKey: ['chartsWatchlist'],
    queryFn: async () => {
      const response = await api.get<ChartsWatchlistResponse>('/charts-watchlist');
      return response.data;
    },
    staleTime: 1 * 60 * 1000, // 1 minute - shorter for fresh shuffling
    gcTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};